
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Utente } from "./authenticationSlice";
import { PermissionTypes } from "./permissionsGroups";

export const useAutorizzazioneGruppi = (gruppiAutorizzati: PermissionTypes[]): boolean => {
    const utente = useSelector<RootState, Utente>((state) => state.authentication.utenteLogged);

    if (utente.is_superuser) return true;
    if (utente.isLogged && gruppiAutorizzati.includes(PermissionTypes.ALL)) return true;
    return gruppiAutorizzati.some((gruppo) => utente.gruppi?.includes(gruppo));
};
